module.exports = __webpack_public_path__ + "images/download@2x.png?2a90a8d8";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/download@2x.png
// module id = 613
// module chunks = 7